/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'actions-operations-chevron-sort': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" d="M10 17.5l-4.375-4.375.881-.881L10 15.73l3.494-3.487.881.881L10 17.5zm0-15l4.375 4.375-.881.881L10 4.27 6.506 7.756l-.881-.881L10 2.5z"/>'
  }
})
